import Faq from '@components/Faq';
import StructuredData from '@components/StructuredData';
import { faqStructuredData } from '@helpers/constants';
import { HeadTagData } from '@helpers/headTagData';
import NextHeadTag from '@ui/molecules/NextHeadTag';
import { useEffect } from 'react';
import {logEvent, moengageEventConstants} from "@services/moengage";

const FaqsPage = () => {

    const onLoad = () => {
        if (typeof window !== 'undefined') {
            // Get the hash from the url
            const hashId = window.location.hash;

            if (hashId) {
                // Use the hash to find the first element with that id
                const element = document.querySelector(hashId);
                if (element) {
                    element.click();
                    setTimeout(() => element.scrollIntoView({ behavior: "smooth", }), 100);

                }
            }
        }
    };

    useEffect(() => {
        logEvent({eventName: moengageEventConstants.VIEWED_FAQ_PAGE,});
        onLoad();
    }, []);

    return (
        <>
            <NextHeadTag {...HeadTagData['/faq']} />
            <StructuredData data={faqStructuredData} />
            <Faq />
        </>
    );
};

export default FaqsPage;
